// extracted by mini-css-extract-plugin
export default {"discountBadge":"_1SKN6","discountIcon":"_2F6S7","xxl":"_26laG","xl":"_3fXQn","lg":"uuleg","md":"_3gT04","sm":"_2AQ60","xs":"_1WKFR"};